import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const apiClient = axios.create({
  baseURL: 'https://apipro.maynor1024.live',
  timeout: 60000, // 60秒超时
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
apiClient.interceptors.request.use(
  config => {
    
    // // 如果有token，添加到请求头
    // const token = localStorage.getItem('authToken')
    // if (token) {
    //   // config.headers.Authorization = `Bearer ${token}`
    //   config.headers.Authorization = `Bearer sk-Rqme1UpB5UStxS0hUVsPQ4u9tBhgLBOYpvYxomjRRX8B1AkB`
    // }
    config.headers.Authorization = `Bearer sk-Rqme1UpB5UStxS0hUVsPQ4u9tBhgLBOYpvYxomjRRX8B1AkB`
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
apiClient.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const errorMsg = error.response?.data?.message || '请求失败，请稍后重试'
    Message.error(errorMsg)
    return Promise.reject(error)
  }
)

export const lessonAPI = {
  // 上传单个文件
  async uploadFile(file, courseId) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('courseId', courseId)
    
    return apiClient.post('/api/lesson/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        console.log('Upload progress:', percentCompleted)
      }
    })
  },

  // 批量上传文件
  async uploadMultipleMaterials(files, courseId) {
    const formData = new FormData()
    files.forEach((file, index) => {
      formData.append(`files`, file)
    })
    formData.append('courseId', courseId)
    
    return apiClient.post('/v1/files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  // 生成教学资源
  async generateResources(params) {
    return apiClient.post('/api/lesson/generate', {
      courseId: params.courseId,
      materialIds: params.materialIds,
      resourceTypes: ['ppt', 'standard', 'plan'] // PPT、课程标准、教案
    })
  },

  // 获取生成进度
  async getGenerationProgress(taskId) {
    return apiClient.get(`/api/lesson/progress/${taskId}`)
  },

  // 下载生成的资源
  async downloadResource(resourceId, filename) {
    try {
      const response = await apiClient.get(`/api/lesson/download/${resourceId}`, {
        responseType: 'blob'
      })
      
      // 创建下载链接
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      
      // 清理
      link.remove()
      window.URL.revokeObjectURL(url)
      
      return true
    } catch (error) {
      console.error('Download failed:', error)
      throw error
    }
  },

  // 获取默认教材
  async useDefaultMaterial(courseId) {
    return apiClient.post('/api/lesson/use-default-material', {
      courseId
    })
  },

  // 预览资源
  async previewResource(resourceId) {
    return apiClient.get(`/api/lesson/preview/${resourceId}`)
  }
}

// 工具函数
export const fileUtils = {
  // 验证文件类型
  validateFileType(file, allowedTypes) {
    const fileExtension = file.name.split('.').pop().toLowerCase()
    const isValidMime = allowedTypes.mimeTypes.includes(file.type)
    const isValidExtension = allowedTypes.extensions.includes(fileExtension)
    return isValidMime || isValidExtension
  },

  // 验证文件大小
  validateFileSize(file, maxSize) {
    return file.size <= maxSize
  },

  // 格式化文件大小
  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }
}